export class FetchTeamsForLeague {
    public static readonly type = '[Team] FetchTeamsForLeague';
    constructor(public leagueId: string) {}
}
